export const createCardsWithPlaceholders = <T>(
    cards: T[],
    totalCardsCount: number,
    placeHolder: T,
): T[] => {
    const newCards = [...(cards ?? [])];

    for (let i = cards?.length ?? 0; i < totalCardsCount; i++) {
        newCards.push(placeHolder);
    }

    return newCards;
};
